const { io } = require('socket.io-client');

// Reads the authToken cookie (works in dev where httpOnly is off).
// In production the browser sends it automatically via the WS upgrade headers.
const getAuthToken = () => {
  const match = document.cookie.match(/(?:^|;\s*)authToken=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
};

// CRA sets NODE_ENV=development for `craco start` (both `npm start` and
// `npm run dev`) and production for `craco build` — no manual toggling needed.
export const graphqlWsEndpoint = process.env.NODE_ENV === 'production'
  ? "https://socket.wfc360.com"
  : "ws://localhost:3600";

export const socket = io(graphqlWsEndpoint, {
  path: '/ws/socket.io/',
  transports: ['websocket'],
  autoConnect: false,          // don't connect at import time — token isn't ready yet
  reconnection: true,
  reconnectionDelay: 2000,
  reconnectionAttempts: 20,
  timeout: 8000,
  // Callback form re-reads the cookie fresh on every connect/reconnect attempt
  auth: (cb) => cb({ token: getAuthToken() }),
});

socket.on('connect', () => {
  console.log('[socket] connected, id:', socket.id);
});

socket.on('disconnect', (reason) => {
  // Do NOT emit here — socket is disconnected, emit would be silently dropped.
  console.log('[socket] disconnected:', reason);
});

socket.on('connect_error', (err) => {
  console.warn('[socket] connect error:', err.message);
});

socket.on('reconnect', (attempt) => {
  console.log('[socket] reconnected after', attempt, 'attempt(s)');
});

socket.on('reconnect_failed', () => {
  console.error('[socket] reconnection failed after all attempts');
});
// Connect to the server manually
export function connectSocket() {
  if (!socket.connected) {
    socket.connect();
  }
}
